// Google Favicon API, mirrors `prefetch_favicon_url` in the backend
// (appquickchat/api/accounts/onboarding_from_url_helpers.py).
export const faviconUrl = (urlOrDomain: string): string | null => {
  // Representative URLs for multi-URL submits look like "https://example.com +4".
  const token = urlOrDomain.trim().split(/\s+/)[0];
  if (!token) return null;
  let domain: string;
  try {
    domain = new URL(token).hostname;
  } catch {
    // Bare domain or netloc+path (e.g. "www.example.com/blog").
    domain = token.split('/')[0];
    if (!domain.includes('.')) return null;
  }
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
};
